module.exports = __webpack_public_path__ + "static/media/48.b0a0a528.gif";